const categories = {
  opbrengsten: {
    label: 'Opbrengsten',
    description:
      'Gemotiveerd worden door dat wat de werkzaamheden jou opleveren: “waar doe jij het voor?”',
    color: 'red-400',
  },
  activiteiten: {
    label: 'Activiteiten',
    description:
      'Carrière Waarden die typen activiteiten aangeven: “wat vind jij prettig om te doen?”',
    color: 'yellow-400',
  },
  omgeving: {
    label: 'Omgeving',
    description:
      'Carrière Waarden die aangeven wat iemand vanuit de omgeving nodig heeft: “wat biedt de omgeving jou?”',
    color: 'green-400',
  },
}

const motivations = [
  {
    label: 'Balans privé-werk',
    key: 'balansprivewerk',
    description:
      'Geeft de balans aan tussen privé en werkleven: "waar wilt u uw energie op richten"?',
    category: null,
  },
  {
    label: 'Financiele beloning',
    key: 'financiele_beloning',
    description: 'Gestimuleerd worden door financiële beloning en inkomen.',
    category: categories.opbrengsten,
  },
  {
    label: 'Waardering en erkenning',
    key: 'waardering_en_erkenning',
    description: 'Graag waardering en erkenning krijgen van anderen.',
    category: categories.opbrengsten,
  },
  {
    label: 'Concrete resultaten',
    key: 'concrete_resultaten',
    description:
      'Resultaten van eigen werkzaamheden willen zien, gericht zijn op concrete resultaten.',
    category: categories.opbrengsten,
  },
  {
    label: 'Zinvolle bijdrage',
    key: 'zinvolle_bijdrage',
    description: 'Een bijdrage leveren die betekenisvol is voor anderen.',
    category: categories.opbrengsten,
  },
  {
    label: 'Carrière',
    key: 'carriere',
    description:
      'Graag veel in het werk willen bereiken, hogerop willen komen.Het leuk vinden om prestaties te vergelijken met anderen.',
    category: categories.opbrengsten,
  },
  {
    label: 'Kwaliteit',
    key: 'kwaliteit',
    description:
      'Een hoge kwaliteit van werk willen leveren, hoge eisen stellen aan het afgeleverde werk.',
    category: categories.opbrengsten,
  },
  {
    label: 'Beïnvloeden',
    key: 'beinvloeden',
    description: 'Het beïnvloeden van processen, mensen en groepen.',
    category: categories.activiteiten,
  },
  {
    label: 'Creatief denken',
    key: 'creatief_denken',
    description:
      'Creatief en vernieuwend bezig zijn, ruimte hebben om te bedenken en te ontwikkelen.',
    category: categories.activiteiten,
  },
  {
    label: 'Ondernemen',
    key: 'ondernemen',
    description: 'Het initiëren van acties, projecten en ondernemingen.',
    category: categories.activiteiten,
  },
  {
    label: 'Hulp verlenen',
    key: 'hulp_verlenen',
    description: 'Iets voor iemand kunnen doen, diensten verlenen.',
    category: categories.activiteiten,
  },
  {
    label: 'Analyseren',
    key: 'analyseren',
    description:
      'Het prettig vinden complexe problemen te analyseren, daarover na te denken.',
    category: categories.activiteiten,
  },
  {
    label: 'Ontwikkelen',
    key: 'ontwikkelen',
    description:
      'Het belangrijk vinden jezelf te kunnen blijven ontwikkelen, te blijven leren in je werk.',
    category: categories.activiteiten,
  },
  {
    label: 'Fysiek actief zijn',
    key: 'fysiek_actief_zijn',
    description:
      'Het prettig vinden lichamelijke arbeid te verrichten, ambachtelijk werk te verrichten.',
    category: categories.activiteiten,
  },
  {
    label: 'Autonomie',
    key: 'autonomie',
    description: 'Het prettig vinden om zelf te kunnen bepalen wat u doet.',
    category: categories.omgeving,
  },
  {
    label: 'Zekerheid en stabiliteit',
    key: 'zekerheid_en_stabiliteit',
    description: 'Het prettig vinden zekerheid en stabiliteit te hebben.',
    category: categories.omgeving,
  },
  {
    label: 'Taakuitdaging',
    key: 'taakuitdaging',
    description:
      'Uitdagingen zoeken, nieuwe of afwisselende taken willen vervullen.',
    category: categories.omgeving,
  },
  {
    label: 'Samenwerking',
    key: 'samenwerking',
    description:
      'Omgaan met mensen, onderdeel uitmaken van een sociaal geheel, een prettige sfeer.',
    category: categories.omgeving,
  },
  {
    label: 'Profilering',
    key: 'aandacht',
    description: 'Graag in de belangstelling staan, aandacht krijgen.',
    category: categories.omgeving,
  },
  {
    label: 'Dynamiek',
    key: 'hectiek',
    description:
      'Het leuk vinden hard te werken. Graag veel te doen willen hebben. In een drukke omgeving willen werken.',
    category: categories.omgeving,
  },
]

export default motivations
